<template>
    <div class="form-item">
        <label class="label-caption">Propriedade</label>
        <select :value="idSelecionado" :disabled="props.disabled" @change="atualizarSelecao" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ `${obj.nmpropriedade} - ${obj.hatotal} ha` }}</option>
        </select>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const emit = defineEmits(['update:idSelecionado', 'update:objSelecionado'])
const props = defineProps({
    ckAddTodos: {type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    idLocalidade: {type: Number, default: 0},
    idPessoa: {type: Number, default: 0},
    idSelecionado: {type: Number, default: null,},
    cpfCnpj: {type: String, default: ''},
})
const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await genericPost('/listas/propriedades', {
            idmunicipio: globalStore.idmunicipio, 
            idpessoa: props.idPessoa,
            idlocalidade: props.idLocalidade,
            cpfcnpj: props.cpfCnpj});
        lsDados.value = response;
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmpropriedade: 'TODAS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;}
}

const atualizarSelecao = (event) => {
    const selectedId = Number(event.target.value);
    emit("update:idSelecionado", selectedId);

    const selectedObj = lsDados.value.find((obj) => obj.id === selectedId);
    if (selectedObj) {emit("update:objSelecionado", selectedObj);}
}

onMounted(() => {
    if (props.ckPesquisar){
        fetchData();
    }
})

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
)

watch(
    () => props.idLocalidade,
    (newVal, oldVal) => {
        if (newVal !== oldVal) {
            fetchData();
        }
    }
)

watch(
    () => props.idPessoa,
    (newVal, oldVal) => {
        if (newVal !== oldVal) {
            fetchData();
        }
    }
)

watch(
    () => props.cpfCnpj,
    (newVal, oldVal) => {
        if (newVal !== oldVal) {
            fetchData();
        }
    }
)
</script>
  